import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getApiUrl } from "../../utils/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import globalErrorHandling from "../../utils/utils";
import ReactTooltip from "react-tooltip";
import Table from "../trademo-datatable/DataTable";
import LoaderImg from "../../assets/images/loader.gif";
import NoSearchDataComponent from "../country-components/no-search-data";
import DataTable from "react-data-table-component";
import moment from "moment";
import { getInternationalNumberSystem } from "../../core/utility/utility";
import { Form } from "react-bootstrap";
import Button from "@components/base/button";
import { ChevronLeft, ChevronRight, Info } from "react-feather";
import commaFormat from "../../utils/commaFormat";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import RedirectProfile from "@shared/country-components/redirect-profile";
import RedirectSampleProfile from "@components/templates/Profile/ProfileLocked/RedirectSampleProfile";
import { getProfileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { profileType, secondLevelRowsDropdown } from "@utils/enum";
import AnalyticsSearch from "./search-with-autosuggest";
import ApplyFilterIcon from "@assets/images/applyFilterIcon.svg";
import DemoTouchPoint from "@routes/intel/onboarding-screens/onboarding/VideoOpenerStrip";
import DynamicDropdown from "@components/base/DynamicDropDown/DynamicDropDown";

const intelAPIEndpoints = {
  downloadExcel: getApiUrl("create_excel_analytics_view_all"),
};

const customStyles = {
  rows: {
    style: {
      maxHeight: "48px",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea !important",
    },
  },
};

const tableCustomStyles = {
  rows: {
    style: {
      maxHeight: "48px",
      minHeight: "48px",
      borderBottom: "none !important",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea !important",
    },
  },
};

const timeFrameOptions = [
  { value: "year", label: "Yearly" },
  { value: "month", label: "Monthly" },
  { value: "quarter", label: "Quarterly" },
];

const safeValue = (v) => (v && v.value ? v.value : 1);

const ViewAllTrends = ({ handleClose, viewTrendsFinalSearchReqObj, country, tradeDirection, currentKeyViewTrendItem, twoColumnMapping, trendsAPI, trendsDropdownOptions: options, analyticsRangeDownloadPresent, pathname, currentUserPlan, analyticsCountryID, countryName, countryType, setAnalytcisSelectedRows, setShowFavModal, userDetails, secondLevelRowDropdownValue, setSecondLevelRowDropDownValue, analyticsViewAllData }) => {
  const [showTrendsModal, setShowTrendsModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [defaultTrendsData, setDefaultTrendsData] = useState([]);
  const [defaultTrendsColumns, setDefaultTrendsColumns] = useState([]);
  const [dynamicTrendsData, setDynamicTrendsData] = useState([]);
  const [dynamicTrendsColumns, setDynamicTrendsColumns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [analysisIndexKey, setAnalysisIndexKey] = useState(null);
  const [trendsTypeIndexKey, setTrendsTypeIndexKey] = useState(null);
  const [analyticsTrends_mustnot_Data, setAnalyticsTrends_mustnot_Data] = useState([]);
  const [dateDiff, setDateDiff] = useState((new Date(viewTrendsFinalSearchReqObj.toDate) - new Date(viewTrendsFinalSearchReqObj.fromDate)) / (1000 * 3600 * 24));
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [clearButton, setClearButton] = useState(false);
  const [showTwoLevel, setShowTwoLevel] = useState(false);
  const [defaultTwoLevelColumn, setDefaultTwoLevelColumn] = useState(currentKeyViewTrendItem.defaultKey);
  const [show, setShow] = useState(false);
  const [downloadFromValue, setDownloadFromValue] = useState(1);
  const [downloadToValue, setDownloadToValue] = useState(100);
  const [showDownloadImpExpModal, setShowDownloadImpExpModal] = useState(false);
  const [existingReqObj, setExistingReqObj] = useState({});
  const [data, setData] = useState([]);
  const [defaultPage, setDefaultPage] = useState(1);
  const [twolevelData, setLevelTwoData] = useState();
  const [viewAllPerPage, setViewAllPerPage] = useState(10);
  const [valueChanged, setValueChanged] = useState(false);
  const [pagination, setPagination] = useState("");
  const [maxPaginate, setMaxPaginate] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [search, setSearch] = useState("");
  //for time-frame
  const [timeFrame, setTimeFrame] = useState(null);

  const currentClass = !currentKeyViewTrendItem.grpType ? "lvl-two-table-container" : "lvl-two-table-container-route";
  const perPageGroups = Math.max(1, Math.floor(viewAllPerPage / safeValue(secondLevelRowDropdownValue)));

  // For dynamic Dropdown
  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggle = (name) => setActiveDropdown(activeDropdown === name ? null : name);
  const close = () => setActiveDropdown(null);

  useEffect(() => {
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
    let tempDateDiff = (new Date(searchRequestObj.toDate) - new Date(searchRequestObj.fromDate)) / (1000 * 3600 * 24);
    setDateDiff(tempDateDiff);
    setTimeFrame(tempDateDiff >= 730 ? timeFrameOptions[0] : tempDateDiff >= 270 ? timeFrameOptions[1] : timeFrameOptions[2]);
    searchRequestObj.must_not = [];
    searchRequestObj.isTrends = true;
    searchRequestObj.order = sortOrder;
    searchRequestObj.trendType = trendsTypeIndexKey !== null || trendsTypeIndexKey === 0 ? timeFrameOptions[trendsTypeIndexKey].value : dateDiff >= 730 ? timeFrameOptions[0].value : dateDiff >= 270 ? timeFrameOptions[1].value : timeFrameOptions[2].value;
    findAnalysisKeyInList(!!viewTrendsFinalSearchReqObj && !!viewTrendsFinalSearchReqObj.analysis && viewTrendsFinalSearchReqObj.analysis !== "" ? viewTrendsFinalSearchReqObj.analysis : "");
    setTimeout(() => {
      viewTrends({ ...searchRequestObj, order: "desc", auto_suggest_search: "" });
      viewTrends({ ...searchRequestObj, is_autosuggest_dropdown: true, auto_suggest_search: "" });
      handleOpen();
    }, 200);
  }, [showTwoLevel, secondLevelRowDropdownValue]);

  useEffect(() => {
    setShowTwoLevel(false);
    setSecondLevelRowDropDownValue(secondLevelRowsDropdown[0]);
  }, []);

  useEffect(() => {
    handleOpen();
  }, [show]);

  const fieldHandler = (row, obj) => {
    if (row?.field4) {
      obj.subFields4 = row.field4;
    }
    if (row?.field3) {
      obj.subFields3 = row.field3;
    }
    if (row?.field2) {
      obj.subFields2 = row.field2;
    }
    if (row?.field1) {
      obj.subFields1 = row.field1;
    }
  };

  const handleSorting = (sortField) => {
    setSortOrder(sortField);
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
    searchRequestObj.must_not = [];
    searchRequestObj.isTrends = true;
    searchRequestObj.trendType = trendsTypeIndexKey !== null || trendsTypeIndexKey === 0 ? timeFrameOptions[trendsTypeIndexKey].value : dateDiff >= 730 ? timeFrameOptions[0].value : dateDiff >= 270 ? timeFrameOptions[1].value : timeFrameOptions[2].value;
    searchRequestObj.order = sortField;
    setSelectedRows([]);
    setAnalytcisSelectedRows([]);
    setTimeout(() => {
      viewTrends(searchRequestObj);
    }, 200);
  };

  useEffect(() => {
    setTimeout(() => {
      handleOpen();
    }, 200);
  }, [defaultTrendsData, data]);

  const viewTrends = (searchRequestObj, comingFrom, type) => {
    if (comingFrom && comingFrom === "pagination") {
      searchRequestObj.must_not = analyticsTrends_mustnot_Data ? analyticsTrends_mustnot_Data : [];
      searchRequestObj.auto_suggest_search = existingReqObj.auto_suggest_search;
    } else {
      searchRequestObj.must_not = [];
      setDataPerPage(10);
      setCurrentPage(1);
    }
    setShowTrendsModal(true);
    setLoader(true);
    if (showTwoLevel) {
      searchRequestObj.isSecondLevelAnalytics = true;
      searchRequestObj.subAnalyticsField = type ? type : defaultTwoLevelColumn;
      searchRequestObj.sub_data_size = secondLevelRowDropdownValue.value;
    } else {
      delete searchRequestObj.isSecondLevelAnalytics;
      delete searchRequestObj.subAnalyticsField;
    }
    if (!searchRequestObj?.auto_suggest_search) {
      searchRequestObj.auto_suggest_search = existingReqObj.auto_suggest_search;
    }
    setExistingReqObj(searchRequestObj);
    axios
      .post(trendsAPI, searchRequestObj)
      .then((res) => {
        if (!!res && !!res.data && !!res.data.data) {
          setDataCount(res.data.count);
          if (res.data.count < downloadToValue) {
            setDownloadToValue(res.data.count);
          }
          setDynamicTrendsData(res.data.headers);
          if (!showTwoLevel) {
            if (comingFrom && comingFrom === "pagination") {
              setTimeout(() => {
                setDefaultTrendsData(defaultTrendsData.concat(res.data.data));
                setAnalyticsTrends_mustnot_Data([...analyticsTrends_mustnot_Data, ...res.data.must_not]);
              }, 1000);
            } else {
              setDefaultTrendsData(res.data.data);
              if (searchRequestObj.auto_suggest_search === "") setAnalyticsTrends_mustnot_Data(res.data.must_not);
              setCurrentPage(1);
            }
            setLoader(false);
          } else {
            if (comingFrom && comingFrom === "pagination") {
              let array = [];
              res.data.data.forEach((item) => {
                if (!!item.sub_data && !!item.sub_data.length) {
                  item.sub_data.forEach((val, index) => {
                    let obj = { ...val, ...item };
                    obj.key = item.key;
                    obj.subKey = val.key;
                    obj.total = item.total_value;
                    obj.s_no = index + 1;
                    obj.showBorder = index + 1 === item.sub_data.length ? true : false;
                    fieldHandler(val, obj);
                    array.push(obj);
                  });
                } else {
                  let obj = { ...item };
                  obj.key = item.key;
                  obj.subKey = "NA";
                  obj.total = item.total_value;
                  obj.s_no = 1;
                  obj.showBorder = true;
                  array.push(obj);
                }
              });
              setTimeout(() => {
                setLevelTwoData(twolevelData.concat(res.data.data));
                setDefaultTrendsData(defaultTrendsData.concat(array));
                setAnalyticsTrends_mustnot_Data([...analyticsTrends_mustnot_Data, ...res.data.must_not]);
                setLoader(false);
              }, 1000);
            } else {
              let array = [];
              res.data.data.forEach((item) => {
                if (!!item.sub_data && !!item.sub_data.length) {
                  item.sub_data.forEach((val, index) => {
                    let obj = { ...val, ...item };
                    obj.key = item.key;
                    obj.subKey = val.key;
                    obj.total = item.total_value;
                    obj.s_no = index + 1;
                    fieldHandler(val, obj);
                    obj.showBorder = index + 1 === item.sub_data.length ? true : false;
                    array.push(obj);
                  });
                } else {
                  let obj = { ...item };
                  obj.key = item.key;
                  obj.subKey = "NA";
                  obj.total = item.total_value;
                  obj.s_no = 1;
                  obj.showBorder = true;
                  array.push(obj);
                }
              });
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setLevelTwoData(res.data.data);
              setDefaultTrendsData(array);
              setAnalyticsTrends_mustnot_Data(res.data.must_not);
            }
          }
        } else if (res?.data?.dropdown_list) {
          let options = res.data.dropdown_list.map((option) => {
            return {
              label: option,
              value: currentKeyViewTrendItem?.key?.includes("hs_code") ? +option.split("-")[0] : option,
            };
          });
          setDropdownOptions(options);
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      });
  };

  const handleClick = (event) => {
    trademoTrackingEvents(analyticsCountryID?.toLowerCase()?.replace("-", "_") + currentKeyViewTrendItem?.label?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsAttribute, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    event.stopPropagation();
    setShow(!show);
  };

  const selectTypeHandler = (type) => {
    setDefaultTwoLevelColumn(type);
    setValueChanged(currentKeyViewTrendItem.defaultKey === type ? false : true);
    setTimeout(() => {
      viewTrends(viewTrendsFinalSearchReqObj, "", type);
      setShow(!show);
    }, 100);
  };

  const handleOpen = () => {
    setShowTrendsModal(true);
    setDefaultTrendsColumns([
      {
        omit: showTwoLevel,
        name: "S No.",
        selector: "id",
        sortable: false,
        grow: 0,
        maxWidth: "42px !important",
        minWidth: "42px !important",
      },
      {
        omit: ((!!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].key) || (!!data && data.length > 0 && !!data[0].key)) && !(currentKeyViewTrendItem.profileType === getProfileTypeEnum.tradeLane) ? false : true,
        name: (
          <span>
            {currentKeyViewTrendItem && currentKeyViewTrendItem.label ? currentKeyViewTrendItem.label.replace("", "") : "Data"}
            <RedirectSampleProfile redirectionType={currentKeyViewTrendItem.profileType} />
          </span>
        ),
        selector: "key",
        sortable: false,
        grow: 1,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.key && row.key !== "" && row.key.length > 30 ? row.key : ""} data-for="first">
            {!showTwoLevel ? (
              <div>
                {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{currentKeyViewTrendItem.profileType ? <RedirectProfile profileId={row.redirection_id} profileType={currentKeyViewTrendItem.profileType} profileName={row.key.slice(0, 20).toLowerCase()} dataSource={analyticsCountryID} countryName={countryName} countryType={countryType} /> : row.key.slice(0, 30).toLowerCase()}</span> : ""}
                {!!row.key && row.key !== "" && row.key.length > 30 ? <span>...</span> : <></>}
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="first" />
              </div>
            ) : (
              <div className="twolevelkeyContainer">
                {row.s_no === 1 ? (
                  <div className="text-left">
                    {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{currentKeyViewTrendItem.profileType ? <RedirectProfile profileId={row.redirection_id} profileType={currentKeyViewTrendItem.profileType} profileName={row.key.slice(0, 20).toLowerCase()} dataSource={analyticsCountryID} countryName={countryName} countryType={countryType} /> : row.key.slice(0, 30).toLowerCase()}</span> : ""}
                    {!!row.key && row.key !== "" && row.key.length > 30 ? <span>...</span> : <></>}
                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="first" />
                    <div className="text-left total_count_twolevl">{options[analysisIndexKey] ? options[analysisIndexKey].table_header : options[0].table_header}</div>
                    <div className="total_count_twolevl">( {showTwoLevel && !!row.total ? commaFormat(row.total) : "NA"} ) </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        ),
      },

      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field1 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerOne ? currentKeyViewTrendItem.headerOne : "Data"}</div>,
        selector: "field1",
        sortable: false,
        grow: 2,
        format: (row) =>
          currentKeyViewTrendItem.profileType === getProfileTypeEnum.tradeLane ? (
            <div data-tip={row.tooltipfield1 ?? ""} data-for="field01">
              {!!row.field1 && row.field1 !== "" ? <span>{row.field1.slice(0, 18)}</span> : ""}
              {!!row.field1 && row.field1 !== "" && row.field1.length > 18 ? <span>...</span> : <></>}
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field01" />
            </div>
          ) : (
            <div className="text-capitalize" data-tip={!!row.field1 && row.field1 !== "" && row.field1.length > 18 ? row.field1 : ""} data-for="field01">
              {!!row.field1 && row.field1 !== "" ? <span>{row.field1.slice(0, 18).toLowerCase()}</span> : ""}
              {!!row.field1 && row.field1 !== "" && row.field1.length > 18 ? <span>...</span> : <></>}
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field01" />
            </div>
          ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field2 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerTwo ? currentKeyViewTrendItem.headerTwo : "Data"}</div>,
        selector: "field2",
        sortable: false,
        grow: 2,
        format: (row) =>
          currentKeyViewTrendItem.profileType === getProfileTypeEnum.tradeLane ? (
            <div data-tip={row.tooltipfield2 ?? ""} data-for="field02">
              {!!row.field2 && row.field2 !== "" ? <span>{row.field2.slice(0, 18)}</span> : ""}
              {!!row.field2 && row.field2 !== "" && row.field2.length > 18 ? <span>...</span> : <></>}
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field02" />
            </div>
          ) : (
            <div className="text-capitalize" data-tip={!!row.field2 && row.field2 !== "" && row.field2.length > 18 ? row.field2 : ""} data-for="field02">
              {!!row.field2 && row.field2 !== "" ? <span>{row.field2.slice(0, 18).toLowerCase()}</span> : ""}
              {!!row.field2 && row.field2 !== "" && row.field2.length > 18 ? <span>...</span> : <></>}
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field02" />
            </div>
          ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field3 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerThree ? currentKeyViewTrendItem.headerThree : "Data"}</div>,
        selector: "field3",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? row.field3 : ""} data-for="field03">
            {!!row.field3 && row.field3 !== "" ? <span>{row.field3.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field03" />
          </div>
        ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field4 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerFour ? currentKeyViewTrendItem.headerFour : "Data"}</div>,
        selector: "field4",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? row.field4 : ""} data-for="field04">
            {!!row.field4 && row.field4 !== "" ? <span>{row.field4.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field04" />
          </div>
        ),
      },
      {
        omit: !(!!data && data.length > 0 && !!data[0].field1 && showTwoLevel && (!!data[0].field1 || !!data[0].field2 || !!data[0].field3 || !!data[0].field4) && !!currentKeyViewTrendItem.grpType),
        name: <div>{currentKeyViewTrendItem.label ? currentKeyViewTrendItem.label.replace("", "") : ""}</div>,
        selector: "field1",
        sortable: false,
        grow: 3,
        format: (row) => (
          <div className="text-capitalize">
            {row.s_no === 1 ? (
              <div className="position-relative">
                {currentKeyViewTrendItem.profileType === getProfileTypeEnum.tradeLane ? (
                  <div data-for="routetooltip" data-tip={row.tooltipfield1 + " → " + row.tooltipfield2} className="d-flex">
                    <RedirectProfile profileId={row.redirection_id} profileType={currentKeyViewTrendItem.profileType} profileName={(row.field1 + " → " + row.field2).length > 100 ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 100) + "..." : (row.field1 + " → " + row.field2).toUpperCase()} dataSource={analyticsCountryID} countryName={countryName} countryType={countryType} />
                  </div>
                ) : (
                  <div data-for="routetooltip" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                    {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 110
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 110) + "..."
                        : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 110
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 110) + "..."
                          : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                          ? (row.field1 + " → " + row.field2).length > 110
                            ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 110) + "..."
                            : (row.field1 + " → " + row.field2).toUpperCase()
                          : !!row && !!row.field1 && typeof row.field1 === "string"
                            ? row.field1.toUpperCase()
                            : ""}
                  </div>
                )}
                <div className="text-left total_count_twolevl">{options[analysisIndexKey] ? "Total " + options[analysisIndexKey].value : options[0].value}</div>
                <div className="total_count_twolevl">( {showTwoLevel && !!row.total ? row.total : ""} ) </div>
              </div>
            ) : (
              ""
            )}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="routetooltip" />
          </div>
        ),
      },
      {
        omit: !showTwoLevel,
        selector: "subKey",
        name: (
          <div className="position-relative">
            <div className="cursor-pointer" onClick={(e) => handleClick(e)}>
              <span>{twoColumnMapping && defaultTwoLevelColumn ? twoColumnMapping[defaultTwoLevelColumn] : ""}</span>
              <img
                className="ml-2"
                src="https://res.cloudinary.com/drzta9shk/image/upload/v1674122072/intel/icons/edit_iohyzc.svg
"
              />
            </div>
            {show ? (
              <div className="position-absolute twoLevelPopOver">
                {Object.keys(twoColumnMapping).map((item) =>
                  (currentKeyViewTrendItem.key === "six_digit_hs_code" ? item !== "four_digit_hs_code" && item !== currentKeyViewTrendItem.key : item !== currentKeyViewTrendItem.key) ? (
                    <div
                      key={item}
                      onClick={() => {
                        setDefaultTwoLevelColumn(item);
                        selectTypeHandler(item);
                      }}
                      className={`px-2 twolevel_option_icons cursor-pointer ${item === defaultTwoLevelColumn ? "py-2 twolevel_option_icons-selected" : "py-2"}`}>
                      <p className="d-flex justify-content-between m-0 ">
                        <span className="cursor-pointer">{item !== currentKeyViewTrendItem.key ? twoColumnMapping[item] : ""}</span>
                        <span>{item === defaultTwoLevelColumn ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                      </p>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ),
        sortable: false,
        grow: 3,
        format: (row) => (
          <div className="text-capitalize d-flex align-items-center">
            <p data-tip={row.subKey} data-for="sub-key" className="m-0 d-flex align-items-center">
              {row.subKey ? row.subKey.slice(0, 60) : ""}
              {!!row.subKey && row.subKey.length > 60 ? "..." : ""}
            </p>
            {valueChanged ? (
              <div className="position-relative">
                <div data-for="sub-key1" data-tip={(!!row.subFields1 && typeof row.subFields1 === "string" ? row.subFields1.toUpperCase() : "") + (!!row.subFields2 && typeof row.subFields2 === "string" ? " → " + row.subFields2.toUpperCase() : "") + (!!row.subFields3 && typeof row.subFields3 === "string" ? " → " + row.subFields3.toUpperCase() : "") + (!!row.subFields4 && typeof row.subFields4 === "string" ? " → " + row.subFields4.toUpperCase() : "")} className="d-flex">
                  {!!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string" && !!row.subFields4 && typeof row.subFields4 === "string"
                    ? (row.subFields1.length > 60 ? row.subFields1.slice(0, 60) + "..." : row.subFields1 + " → " + row.subFields2.length > 60 ? row.subFields2.slice(0, 60) + "..." : row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).length > 110
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase().slice(0, 110) + "..."
                      : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase()
                    : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string"
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).length > 110
                        ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase().slice(0, 110) + "..."
                        : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase()
                      : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string"
                        ? (row.subFields1 + " → " + row.subFields2).length > 110
                          ? (row.subFields1 + " → " + row.subFields2).toUpperCase().slice(0, 110) + "..."
                          : (row.subFields1 + " → " + row.subFields2).toUpperCase()
                        : !!row && !!row.subFields1 && typeof row.subFields1 === "string"
                          ? row.subFields1.toUpperCase()
                          : ""}
                </div>
              </div>
            ) : (
              ""
            )}

            <ReactTooltip
              getContent={[
                (dataTip) => {
                  return (
                    <span>
                      {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                      {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                      {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                    </span>
                  );
                },
                100,
              ]}
              className="trademo-tooltip"
              backgroundColor="#8C8C8C"
              textColor="#FFFFFF"
              place="top"
              id="sub-key"
            />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
          </div>
        ),
      },
      {
        name: <span>{analysisIndexKey ? options[analysisIndexKey].table_header : options[0].table_header}</span>,
        selector: "data_value",
        sortable: showTwoLevel ? false : true,
        maxWidth: "108px !important",
        minWidth: "108px !important",
        grow: 2,
        format: (row) => (
          <div>
            {row.data_value !== null || row.data_value === 0 ? (typeof row.data_value === "number" ? getInternationalNumberSystem(row.data_value) : row.data_value) : ""}
            {showTwoLevel ? <span className="d-block two_level_per_change text-left">{row.data_value_percentage ? "(" + row.data_value_percentage + "%)" : "NA"}</span> : ""}
          </div>
        ),
      },
      {
        name: (
          <div className="d-flex align-items-center">
            % Overall Change
            <div>
              <Info className="mx-1" place="middle" color="#8C8C8C" size={13} data-tip={"% Overall Change is the relative percentage change between the Trade Volume for the earliest and latest time period"} data-for="xyz" />
              <ReactTooltip className="overall-change__tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" />
            </div>
          </div>
        ),
        selector: "overall_percent_change",
        sortable: false,
        maxWidth: "121px !important",
        right: true,
        grow: 1,
        format: (row) => <div>{row.overall_percent_change >= 0 ? <span className="positive">↑{row.overall_percent_change}%</span> : <span className="negative">↓{Math.abs(row.overall_percent_change)}%</span>}</div>,
      },
    ]);
    let arr = [];
    dynamicTrendsData?.forEach((item, index) => {
      const column = {
        name:
          index === 0 ? (
            <div className="tw-w-full tw-h-full trends-tooltip-cell" data-tip="Trends are updated to the latest shipment date" data-for={`header-tooltip-${index}`} style={{ whiteSpace: "nowrap" }}>
              <div>
                {item}
                <svg xmlns="http://www.w3.org/2000/svg" height="8px" viewBox="0 -960 960 960" width="8px" fill="#101828" style={{ marginTop: "-10px" }}>
                  <path d="M454-164v-252.85L274.92-238.16l-36.76-36.76L416.85-454H164v-52h252.85L238.16-685.08l36.76-36.38L454-542.77V-796h52v253.23l179.08-178.69 36.38 36.38L542.77-506H796v52H542.77l178.69 179.08-36.38 36.76L506-416.85V-164h-52Z" />
                </svg>
              </div>
              <ReactTooltip id={`header-tooltip-${index}`} className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" />
            </div>
          ) : (
            item
          ),
        selector: "id",
        sortable: false,
        right: true,
        grow: 0,
        separator: true,
        format: (row) => (
          <div className="text-right">
            <span className="">{row[item] !== undefined && row[item] !== null && row[item].value !== undefined && row[item].value !== null ? getInternationalNumberSystem(row[item].value) : ""}</span>
            <br />
            {index !== dynamicTrendsData.length - 1 ? row[item] && (row[item].percent_change || row[item].percent_change === 0) && row[item].percent_change >= 0 ? <span className="growth-change positive text-right">↑{row[item].percent_change.toFixed(2)}%</span> : row[item] && (row[item].percent_change || row[item].percent_change === 0) ? <span className="growth-change negative text-right">↓{Math.abs(row[item].percent_change).toFixed(2)}%</span> : "" : ""}
          </div>
        ),
      };
      arr.push(column);
    });

    if (!showTwoLevel && !currentKeyViewTrendItem.key.includes("trends")) {
      arr.push({
        name: "Apply Filter",
        sortable: false,
        grow: 0,
        center: true,
        selector: (row) => (
          <div onClick={() => redirectingUserMiddleware(row)} className="text-center cursor-pointer">
            <img src={ApplyFilterIcon} />
          </div>
        ),
      });
    }
    setDynamicTrendsColumns(arr);
  };

  const trendsModalClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    handleClose(true);
    setShowTrendsModal(false);
    setAnalyticsTrends_mustnot_Data([]);
  };

  const bindGroupByResultValue = (data, paginationStr) => {
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrendsSortBy, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
    if (!!data && data !== "") {
      searchRequestObj.analysis = data;
      findAnalysisKeyInList(data);
    }
    if (!!paginationStr && paginationStr !== "") {
      searchRequestObj.must_not = analyticsTrends_mustnot_Data;
    } else {
      setAnalyticsTrends_mustnot_Data([]);
      setDefaultTrendsData([]);
      setDynamicTrendsData([]);
      setSelectedRows([]);
      setAnalytcisSelectedRows([]);
      searchRequestObj.must_not = [];
    }
    viewTrends(searchRequestObj);
  };

  const bindTimeFrame = (data, paginationStr) => {
    switch (data) {
      case "year":
        trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrendsYoY, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
        break;
      case "month":
        trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrendsMoM, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
        break;
      case "quarter":
        trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrendsQoQ, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
        break;
      default:
        break;
    }
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
    if (!!data && data !== "") {
      searchRequestObj.trendType = data;
      findTrendsKeyInList(data);
    }
    if (!!paginationStr && paginationStr !== "") {
      searchRequestObj.must_not = analyticsTrends_mustnot_Data;
    } else {
      setAnalyticsTrends_mustnot_Data([]);
      setDefaultTrendsData([]);
      setDynamicTrendsData([]);
      setSelectedRows([]);
      setAnalytcisSelectedRows([]);
      searchRequestObj.must_not = [];
    }
    viewTrends(searchRequestObj);
  };

  const selectedRowCheck = (row) => {
    return selectedRows.includes(row) === true ? true : false;
  };

  const mapSelectedValue = (data) => {
    setTimeout(() => {
      setSelectedRows([...data]);
      setAnalytcisSelectedRows([...data].map((row) => ({ ...row, key: row?.field1 ? `${row?.field1} (${row?.tooltipfield1}) to ${row?.field2} (${row?.tooltipfield2})` : row?.key })));
    }, 100);
  };

  const callingDownloadAPI = (data, isRangeViewAll) => {
    const downloadPayload = {};
    if (!isRangeViewAll) {
      downloadPayload.data_download = [...data];
      downloadPayload._payload = existingReqObj;
      downloadPayload._payload.email = false;
    } else {
      downloadPayload._payload = existingReqObj;
      downloadPayload._payload.from = downloadFromValue - 1;
      downloadPayload._payload.size = Math.abs(downloadToValue - downloadFromValue) + 1;
      downloadPayload._payload.email = true;
      downloadPayload._payload.must_not = [];
    }
    if (showTwoLevel) {
      downloadPayload.subAnalyticsField = defaultTwoLevelColumn;
      downloadPayload._payload.sub_data_size = secondLevelRowDropdownValue.value;
    }

    if (+downloadToValue < +downloadFromValue) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }

    downloadPayload.isSecondLevelAnalytics = showTwoLevel ? true : false;
    downloadPayload.isRangeViewAll = isRangeViewAll === true ? isRangeViewAll : false;
    downloadPayload.file_name = "Analytics_TrendsViewAll_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    downloadPayload.analysis = !!viewTrendsFinalSearchReqObj && !!viewTrendsFinalSearchReqObj.analysis && viewTrendsFinalSearchReqObj.analysis !== "" ? viewTrendsFinalSearchReqObj.analysis : "";
    downloadPayload.tradeDirection = !!tradeDirection && tradeDirection !== "" ? tradeDirection : "";
    downloadPayload.country = !!country && country !== "" ? country : "";
    downloadPayload.headers = dynamicTrendsData ? dynamicTrendsData : [];
    downloadPayload.analyticsField = !!viewTrendsFinalSearchReqObj && !!viewTrendsFinalSearchReqObj.analyticsField ? viewTrendsFinalSearchReqObj.analyticsField : "";
    if (isRangeViewAll) {
      axios
        .post(intelAPIEndpoints.downloadExcel, downloadPayload)
        .then(
          (res) => {
            if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
              toast.success(res.data.message);
              setShowDownloadImpExpModal(false);
              setDownloadFromValue(1);
              setDownloadToValue(100);
            } else {
              globalErrorHandling(res);
            }
          },
          (error) => {
            toast.error(error?.response?.data?.message || "Something went wrong. Please try again later !!!");
          }
        )
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong. Please try again later !!!");
        });
    } else {
      axios
        .post(intelAPIEndpoints.downloadExcel, downloadPayload)
        .then(({ data }) => {
          window.open(data?.file_url);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong. Please try again later !!!");
        });

      setShowDownloadImpExpModal(false);
      setDownloadFromValue(1);
      setDownloadToValue(100);
    }
  };

  const findAnalysisKeyInList = (analysisValue) => {
    const index = options.findIndex((option) => option.value === analysisValue);
    setAnalysisIndexKey(index !== -1 ? index : 0);
  };

  const findTrendsKeyInList = (trendsValue) => {
    const index = timeFrameOptions.findIndex((option) => option.value === trendsValue);
    setTrendsTypeIndexKey(index !== -1 ? index : null);
  };
  const handleSearchPerRowsChange = (e) => {
    setDataPerPage(e);
  };
  const handlePageChange = (e) => {
    setCurrentPage(e);
    if (defaultTrendsData.length <= e * dataPerPage) {
      if (e * dataPerPage < dataCount) {
        // equal to removed to handle equal data issue
        let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
        viewTrends(searchRequestObj, "pagination");
      }
    }
  };

  const downloadRangeFilter = () => {
    trademoTrackingEvents(analyticsCountryID?.toLowerCase()?.replace("-", "_") + currentKeyViewTrendItem?.label?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsTabDashletTrendsDownloadExcelSendEmail, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));

    if (currentKeyViewTrendItem.profileTypeKey === profileType.logistics) {
      setShowDownloadImpExpModal(false);
      setShowConfirmModal(true);
    } else callingDownloadAPI("", true);
  };

  useEffect(() => {
    if (!twolevelData || !twolevelData.length) {
      setData([]);
      return;
    }

    const perPageGroups = Math.max(1, Math.floor(viewAllPerPage / safeValue(secondLevelRowDropdownValue)));
    const searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};

    const startIndex = (defaultPage - 1) * perPageGroups;
    const endIndex = startIndex + perPageGroups - 1;

    if (!twolevelData[endIndex] && endIndex < dataCount) {
      viewTrends(searchRequestObj, "pagination");
      return;
    }

    const array = [];
    for (let i = startIndex; i <= endIndex; i++) {
      if (!twolevelData[i]) continue;
      const item = twolevelData[i];
      if (item.sub_data && item.sub_data.length) {
        item.sub_data.forEach((val, index) => {
          const obj = { ...val, ...item };
          obj.key = item.key;
          obj.subKey = val.key;
          obj.total = item.total_value;
          obj.s_no = index + 1;
          fieldHandler(val, obj);
          obj.showBorder = index + 1 === item.sub_data.length;
          array.push(obj);
        });
      } else {
        const obj = { ...item };
        obj.key = item.key;
        obj.subKey = "NA";
        obj.total = item.total_value;
        obj.s_no = 1;
        obj.showBorder = true;
        array.push(obj);
      }
    }

    setData([]);
    setTimeout(() => setData([...array]), 100);
  }, [defaultPage, viewAllPerPage, pagination, twolevelData, secondLevelRowDropdownValue]);

  useEffect(() => {
    if (data.length) {
      const val = document.querySelectorAll(`.${currentClass} .rdt_Pagination select option`);
      if (val && val.length >= 2) {
        val[0].textContent = 2;
        val[1].textContent = 5;
      }

      const range = document.querySelectorAll(`.${currentClass} .rdt_Pagination span`);
      if (range && range.length) {
        const startIndex = (defaultPage - 1) * perPageGroups;
        const endIndex = Math.min(startIndex + perPageGroups - 1, dataCount - 1);
        range[1].textContent = `${startIndex + 1} - ${Math.max(Math.min(endIndex + 1, dataCount), startIndex + 1)} of ${commaFormat(dataCount)}`;
      }

      const prevPage = document.querySelectorAll(`.${currentClass} #pagination-previous-page`);
      if (prevPage && prevPage.length) {
        if (defaultPage > 1) prevPage[0].removeAttribute("disabled");
        else prevPage[0].setAttribute("disabled", true);
      }

      const nextPage = document.querySelectorAll(`.${currentClass} #pagination-next-page`);
      if (nextPage && nextPage.length) {
        if (defaultPage * perPageGroups >= dataCount) nextPage[0].setAttribute("disabled", true);
        else nextPage[0].removeAttribute("disabled");
      }

      const rows = document.querySelectorAll(`.${currentClass} .rdt_TableRow`);
      if (rows && rows.length) {
        data.forEach((item, index) => {
          if (!item.showBorder && rows[index]) {
            const firstChild = rows[index].firstChild;
            firstChild.style.setProperty("border-bottom", "none", "important");
          }
        });
      }

      const pagination = document.querySelectorAll(`.${currentClass} .rdt_Pagination`);
      if (pagination && pagination.length && data && data.length < 8) {
        pagination[0].style.marginTop = -(48 * (10 - data.length)) + 30 + "px";
      }
    }
  });

  const redirectingUserMiddleware = (row) => {
    if (!!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].allHsCode) {
      redirectingUser(row.allHsCode);
    } else if (defaultTrendsData[0].hsCodes) {
      redirectingUser(row.hsCodes);
    } else if (defaultTrendsData[0].description) {
      redirectingUser(row.description);
    } else if (defaultTrendsData[0].filterKey) {
      redirectingUser(row.filterKey);
    } else if (defaultTrendsData[0].key) {
      redirectingUser(row.key);
    } else if (viewTrendsFinalSearchReqObj?.analyticsField?.includes("trade_")) {
      let field1 = row.field1;
      let field2 = row.field2;
      let field3 = row.field3;
      let field4 = row.field4;
      redirectingUser(field1, field2, field3, field4);
    } else if (viewTrendsFinalSearchReqObj.analyticsField === "derived_country_of_origin_port_of_lading_country_country_of_export") {
      let field1 = row.field1;
      let field2 = row.field2;
      let field3 = row.field3;
      redirectingUser(field1, field2, field3);
    } else if (viewTrendsFinalSearchReqObj?.analyticsField === "derived_port_of_lading_port_of_lading_country_customs_house_name" || viewTrendsFinalSearchReqObj?.analyticsField === "derived_customs_house_name_country_of_destination" || viewTrendsFinalSearchReqObj?.analyticsField === "derived_custom_office_destination_name_derived_country_of_destination_english") {
      let field1 = row.field1;
      let field2 = row.field2;
      redirectingUser(field1, field2);
    } else {
      let field1 = row.field1;
      let field2 = row.field2;
      redirectingUser(field1, field2);
    }
  };

  const redirectingUser = (data1, data2, data3, data4) => {
    let tempObj = {
      analyticsViewAllKey: viewTrendsFinalSearchReqObj.analyticsField,
      filter_value1: "",
      filter_value2: !!data2 && data2 !== "" ? data2 : "",
      filter_value3: "",
      filter_value4: "",
      analysisOption: options?.[analysisIndexKey]?.value,
    };
    if (viewTrendsFinalSearchReqObj.analyticsField === "sections" || viewTrendsFinalSearchReqObj.analyticsField === "derived_hs_codes") {
      tempObj.filter_value1 = !!data1 && data1.length !== 0 ? data1 : [];
    } else {
      tempObj.filter_value1 = !!data1 && data1 !== "" ? data1 : "";
    }
    if (data3) tempObj.filter_value3 = data3;
    if (data4) tempObj.filter_value4 = data4;
    analyticsViewAllData(tempObj);
    trendsModalClose();
  };

  const applyMultiFilterHandler = () => {
    if (defaultTrendsData.length > 0 && !!defaultTrendsData[0].allHsCode) {
      let allHsCode = [...new Set(selectedRows.map((item) => item.allHsCode))];
      redirectingUser(allHsCode);
    } else if (defaultTrendsData[0].hsCodes) {
      let allHsCode = [...new Set(selectedRows.map((item) => item.hsCodes))];
      redirectingUser(allHsCode);
    } else if (defaultTrendsData[0].description) {
      let description = [...new Set(selectedRows.map((item) => item.description))];
      redirectingUser(description);
    } else if (defaultTrendsData[0].filterKey) {
      let filterKey = [...new Set(selectedRows.map((item) => item.filterKey))];
      redirectingUser(filterKey);
    } else if (defaultTrendsData[0].key) {
      let key = [...new Set(selectedRows.map((item) => item.key))];
      redirectingUser(key);
    } else if (viewTrendsFinalSearchReqObj?.analyticsField?.includes("trade_")) {
      let field1 = [...new Set(selectedRows.map((item) => item.field1))];
      let field2 = [...new Set(selectedRows.map((item) => item.field2))];
      let field3 = [...new Set(selectedRows.map((item) => item.field3))];
      let field4 = [...new Set(selectedRows.map((item) => item.field4))];
      redirectingUser(field1, field2, field3, field4);
    } else if (viewTrendsFinalSearchReqObj?.analyticsField === "derived_country_of_origin_port_of_lading_country_country_of_export") {
      let field1 = [...new Set(selectedRows.map((item) => item.field1))];
      let field2 = [...new Set(selectedRows.map((item) => item.field2))];
      let field3 = [...new Set(selectedRows.map((item) => item.field3))];
      redirectingUser(field1, field2, field3);
    } else if (viewTrendsFinalSearchReqObj?.analyticsField === "derived_port_of_lading_port_of_lading_country_customs_house_name" || viewTrendsFinalSearchReqObj?.analyticsField === "derived_customs_house_name_country_of_destination" || viewTrendsFinalSearchReqObj?.analyticsField === "derived_custom_office_destination_name_derived_country_of_destination_english") {
      let field1 = [...new Set(selectedRows.map((item) => item.field1))];
      let field2 = [...new Set(selectedRows.map((item) => item.field2))];
      redirectingUser(field1, field2);
    } else {
      let field1 = [...new Set(selectedRows.map((item) => item.field1))];
      let field2 = [...new Set(selectedRows.map((item) => item.field2))];
      redirectingUser(field1, field2);
    }
  };

  return (
    <div>
      <Modal show={showTrendsModal} onHide={(e) => trendsModalClose(e)} size="xl" onClick={() => setShow(false)} keyboard={false} centered className="trademo-modal trademo-trends-modal">
        <Modal.Header closeButton>
          <div className="d-flex tw-justify-between w-100">
            <div className="tw-flex tw-items-center tw-gap-2">
              <h4>{currentKeyViewTrendItem && currentKeyViewTrendItem.label ? currentKeyViewTrendItem.label.replace("", "") + ": Trends" : "Data"}</h4>
              <span className="tw-relative">
                <DynamicDropdown
                  isOpen={activeDropdown === "timeframe"}
                  dropdownValue={activeDropdown}
                  onToggle={() => toggle("timeframe")}
                  onClose={close}
                  buttonLabel={`${timeFrame?.label}`}
                  options={timeFrameOptions}
                  onSelect={(e) => {
                    bindTimeFrame(e.value, "");
                    setTimeFrame(e);
                  }}
                  buttonId="time-frame-dropdown"
                  icon={{ after: false, before: true, onClose: "keyboard_arrow_down", onOpen: "keyboard_arrow_up" }}
                />
              </span>
            </div>
            {currentKeyViewTrendItem.showlevelTwo ? (
              <>
                <div className="d-flex align-items-center">
                  <span className="d-flex item-center justify-content-end">
                    <span className="mr-1 two_level_label">2nd Level Analytics</span>
                  </span>
                  <span className={showTwoLevel ? "twolevel-checkbox cursor-pointer" : "twolevel-checkbox-uncheck cursor-pointer"}>
                    <Form.Check
                      type="switch"
                      id="custom-switch-10"
                      onChange={(e) => {
                        setShowTwoLevel(e.target.checked);
                        setClearButton(!clearButton);
                        setDefaultPage(1);
                        setSelectedRows([]);
                        setAnalytcisSelectedRows([]);
                        setDefaultTrendsData([]);
                        setSearch("");
                        setCurrentPage(1);
                        setData([]);
                        if (e.target.checked) {
                          trademoTrackingEvents(analyticsCountryID?.toLowerCase()?.replace("-", "_") + currentKeyViewTrendItem?.label?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalytics, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                        }
                      }}
                    />
                  </span>
                </div>
                <div className="tw-w-10 tw-flex tw-justify-end">
                  <DemoTouchPoint module="how_to_analyse_trends_viewTrends_page" />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          {loader && loader !== "" ? (
            <div className="container py-5 my-5 loading-container">
              <div className="text-center pt-3">
                <img src={LoaderImg} alt="description of gif" />
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12 d-flex pb-3">
                <div className="col-md-5 my-auto pl-0">
                  {!currentKeyViewTrendItem.key.includes("trends") && <AnalyticsSearch dropdownOptions={dropdownOptions} setSelectedRows={setSelectedRows} viewTrends={viewTrends} currentKeyViewTrendItem={currentKeyViewTrendItem} existingReqObj={existingReqObj} search={search} setSearch={(value) => setSearch(value.trim())} />}
                  <div>
                    {analyticsRangeDownloadPresent && selectedRows && selectedRows.length === 0 ? (
                      <Button
                        variant="secondaryWithIcon"
                        size="small"
                        className="tw-ml-1 tw-mr-2 tw-h-8 tw-font-medium tw-text-sm tw-flex tw-items-center disabled:tw-cursor-not-allowed"
                        onClick={() => {
                          setShowDownloadImpExpModal(true);
                          setDownloadToValue(dataCount < 100 ? dataCount : 100);
                          setDownloadFromValue(1);
                          trademoTrackingEvents(analyticsCountryID?.toLowerCase()?.replace("-", "_") + currentKeyViewTrendItem?.label?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsTabDashletTrendsDownloadExcel, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                        }}
                        id="shipment-default-download-excel-button">
                        <span className="material-symbols-outlined">cloud_download</span>
                        <span className="ml-1">Download Excel</span>
                      </Button>
                    ) : (
                      ""
                    )}
                    {selectedRows && selectedRows.length > 0 ? (
                      <div className="d-flex justify-content-between">
                        <div className={`selected-state-row d-flex align-items-center selected-top-box px-1 ${selectedRows.length > 0 ? null : "d-none"}`}>
                          <span className="mx-1">
                            {selectedRows.length > 0 ? (
                              <span className="selected-search-count d-flex align-items-center">
                                <span className={`row-select-count mr-1 ${selectedRows.length > 9 ? "padding" : "extra-padding"}`}>{selectedRows.length}</span>
                                <span>{selectedRows.length === 1 ? "row selected" : "rows selected"}</span>
                              </span>
                            ) : (
                              <></>
                            )}
                          </span>
                          <span className="vr max-1" />
                          {currentKeyViewTrendItem?.isFavourite && userDetails?.creditDetails?.planAccess?.is_logistic_profile ? (
                            <span
                              className="mx-1 d-flex cursor-pointer align-items-center d-flex align-items-center"
                              onClick={(e) => {
                                setShowFavModal(true);
                                trendsModalClose(e);
                              }}>
                              <span className="material-symbols-outlined">star</span>
                              <span>Bookmark</span>
                            </span>
                          ) : (
                            <></>
                          )}
                          {!currentKeyViewTrendItem.key.includes("trends") ? (
                            <span className="mx-1 d-flex cursor-pointer align-items-center d-flex align-items-center tw-gap-1" onClick={() => applyMultiFilterHandler()}>
                              <img src={ApplyFilterIcon} />
                              <span>Apply Filter</span>
                            </span>
                          ) : null}
                          <span className="vr mx-1" />
                          <span
                            className="mx-1 d-flex cursor-pointer align-items-center"
                            onClick={() => {
                              if (currentKeyViewTrendItem.profileTypeKey === profileType.logistics) {
                                setShowConfirmModal(true);
                              } else {
                                callingDownloadAPI(selectedRows);
                              }
                            }}>
                            <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875670/intel/Importer-Exporter_Tab/leftbar_icon_download_fqdhxy.svg" alt="Download Icon" />
                            <span>Download</span>
                          </span>
                          <span className="vr mx-1" />
                          <span className="mx-1 d-flex cursor-pointer align-items-center" onClick={() => setClearButton(!clearButton)}>
                            <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875752/intel/Importer-Exporter_Tab/leftbar_icon_close_jl6z6l.svg" alt="Clear Icon" />
                            <span>Clear</span>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="sort-dropdown d-flex justify-content-end ml-2 pl-5 tw-gap-2">
                    <div>
                      {showTwoLevel && (
                        <DynamicDropdown
                          isOpen={activeDropdown === "secondLevelEntities"}
                          dropdownValue={activeDropdown}
                          onToggle={() => toggle("secondLevelEntities")}
                          onClose={close}
                          buttonLabel={`No. of 2nd Level Entities : ${secondLevelRowDropdownValue.label}`}
                          options={secondLevelRowsDropdown}
                          onSelect={(value) => {
                            setSecondLevelRowDropDownValue(value);
                            setViewAllPerPage(value.value * 2);
                            setDefaultPage(1);
                            setCurrentPage(1);
                          }}
                          buttonId="second-level-entities"
                          icon={{ after: true, before: false, onClose: "keyboard_arrow_down", onOpen: "keyboard_arrow_up" }}
                        />
                      )}
                    </div>
                    <div className="tw-relative">
                      <DynamicDropdown
                        isOpen={activeDropdown === "sort"}
                        dropdownValue={activeDropdown}
                        onToggle={() => toggle("sort")}
                        onClose={close}
                        buttonLabel={`Sort By: ${analysisIndexKey ? options[analysisIndexKey].label : options[0].label}`}
                        options={options}
                        onSelect={(item) => {
                          bindGroupByResultValue(item.value, "");
                          close();
                        }}
                        buttonId="sort-dropdown"
                        icon={{ after: false, before: true, onClose: "swap_vert", onOpen: "swap_vert" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card w-100 trademo-datatable-card">
                <div className="d-flex trends-table">
                  <div className={!!defaultTrendsData && defaultTrendsData.length > 0 && ((!!defaultTrendsData[0].field3 && defaultTrendsData[0].field3 !== "") || (!!defaultTrendsData[0].field4 && defaultTrendsData[0].field4 !== "")) ? "col-8 pr-0" : showTwoLevel ? "col-7 px-0" : "col-5 px-0"}>
                    {!showTwoLevel ? (
                      <div className="react-two-level-trends-datatable">
                        <Table title="Data1" columns={defaultTrendsColumns} paginationTotalRows={dataCount} data={!!defaultTrendsData && defaultTrendsData !== "" ? defaultTrendsData : []} pagination persistTableHead onSort={(e, sortField) => handleSorting(sortField)} defaultSortAsc={sortOrder === "desc" ? false : true} selectableRows={!!country && country !== "" ? true : false} defaultSortField="data_value" selectableRowSelected={selectedRowCheck} onSelectedRowsChange={(selectedRows) => mapSelectedValue(selectedRows)} paginationRowsPerPageOptions={[10, 20, 30]} paginationPerPage={dataPerPage} selectedData={selectedRows} onChangePage={(e) => handlePageChange(e ? e : 1)} onChangeRowsPerPage={(e) => handleSearchPerRowsChange(e)} paginationDefaultPage={currentPage} clearSelectedRows={clearButton} paginationIconPrevious={<ChevronLeft />} paginationIconNext={<ChevronRight />} />
                      </div>
                    ) : (
                      <div className={`twolevel ${currentClass}`}>
                        {!!data.length && !!dynamicTrendsColumns.length ? (
                          <DataTable
                            title="Companies"
                            columns={defaultTrendsColumns}
                            paginationTotalRows={dataCount}
                            className="trademo-datatable trademo-custom-table2"
                            sortIcon={
                              <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000000">
                                <path d="M480-116 229.08-366.92l36.77-36.77L454-215.15v-629.23h52v628.84l188.15-188.15 36.77 36.77L480-116Z" />
                              </svg>
                            }
                            data={!!data && data !== "" ? data : []}
                            customStyles={tableCustomStyles}
                            pagination
                            persistTableHead
                            highlightOnHover
                            paginationIconFirstPage={<></>}
                            paginationIconLastPage={<></>}
                            onSort={(e, sortField) => handleSorting(sortField)}
                            defaultSortAsc={sortOrder === "desc" ? false : true}
                            paginationRowsPerPageOptions={[safeValue(secondLevelRowDropdownValue) * 2, safeValue(secondLevelRowDropdownValue) * 5]}
                            paginationPerPage={viewAllPerPage}
                            onChangeRowsPerPage={(data) => {
                              setViewAllPerPage(data);
                              setDefaultPage(1);
                              trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsPaginationResultPerPage, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                            }}
                            paginationDefaultPage={defaultPage}
                            paginationIconPrevious={
                              <ChevronLeft
                                color={defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                                onClick={() => {
                                  if (defaultPage > 1) {
                                    setDefaultPage(defaultPage - 1);
                                    setPagination("prev");
                                  }
                                }}
                              />
                            }
                            paginationIconNext={
                              <ChevronRight
                                onClick={() => {
                                  if (defaultPage * perPageGroups >= dataCount) return;
                                  setDefaultPage(defaultPage + 1);
                                  if (defaultPage >= maxPaginate) setMaxPaginate(maxPaginate + 1);
                                  setPagination("next");
                                }}
                              />
                            }
                            noDataComponent={<NoSearchDataComponent content="No Results Found. Please try another search" />}
                          />
                        ) : (
                          dynamicTrendsColumns.length === 0 && <NoSearchDataComponent content="No Results Found. Please try another search" />
                        )}
                      </div>
                    )}
                  </div>
                  <div className={!!defaultTrendsData && defaultTrendsData.length > 0 && ((!!defaultTrendsData[0].field3 && defaultTrendsData[0].field3 !== "") || (!!defaultTrendsData[0].field4 && defaultTrendsData[0].field4 !== "")) ? "col-4 pl-0 react-two-level-trends-datatable-right" : showTwoLevel ? "col-5 px-0 react-two-level-trends-datatable-right" : "col-7 px-0 react-two-level-trends-datatable-right"}>
                    {/* className={"trademo-datatable trademo-custom-table2"} */}
                    {!showTwoLevel ? (
                      <div>
                        <DataTable
                          title="Data2"
                          className="trademo-datatable trademo-custom-table2"
                          sortIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000000">
                              <path d="M480-116 229.08-366.92l36.77-36.77L454-215.15v-629.23h52v628.84l188.15-188.15 36.77 36.77L480-116Z" />
                            </svg>
                          }
                          columns={dynamicTrendsColumns}
                          data={!!defaultTrendsData && defaultTrendsData !== "" ? defaultTrendsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage) : []}
                          customStyles={customStyles}
                          persistTableHead
                          highlightOnHover
                          noDataComponent={<NoSearchDataComponent content="No Results Found. Please try another search" className="trends_no_search_component" />}
                        />
                      </div>
                    ) : (
                      <div className="leveltwo-analytics-table">
                        {!!data.length && !!dynamicTrendsColumns.length ? (
                          <DataTable
                            title="Data2"
                            sortIcon={
                              <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000000">
                                <path d="M480-116 229.08-366.92l36.77-36.77L454-215.15v-629.23h52v628.84l188.15-188.15 36.77 36.77L480-116Z" />
                              </svg>
                            }
                            className="trademo-datatable trademo-custom-table2"
                            columns={dynamicTrendsColumns}
                            data={!!data && data !== "" ? data : []}
                            customStyles={customStyles}
                            pagination
                            persistTableHead
                            highlightOnHover
                            noDataComponent={<NoSearchDataComponent content="No Results Found. Please try another search" />}
                            paginationRowsPerPageOptions={[10, 25]}
                            paginationPerPage={viewAllPerPage}
                            paginationDefaultPage={defaultPage}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal
          className="trademo-impexpmodal"
          centered
          show={showDownloadImpExpModal}
          onHide={() => {
            setShowDownloadImpExpModal(false);
            setDownloadFromValue(1);
            setDownloadToValue(100);
            setSecondLevelRowDropDownValue(secondLevelRowsDropdown[0]);
          }}
          animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Download Excel </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row m-0 ">
              <div className="col-6 p-0">
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                <span className="label-value line-height-32">Select records by S.No</span>
              </div>
              <div className="col-6 p-0">
                <div className="row m-0">
                  <div className="col-5 pr-0">
                    <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="From" type="number" value={downloadFromValue} onChange={(e) => setDownloadFromValue(e.target.value)} />
                  </div>
                  <div className="col-2">
                    <span className="label-value line-height-32">to</span>
                  </div>
                  <div className="col-5 pr-0">
                    <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="To" type="number" value={downloadToValue} onChange={(e) => setDownloadToValue(e.target.value > dataCount ? dataCount : e.target.value)} />
                  </div>
                </div>
                {downloadFromValue && !!downloadToValue && downloadToValue - downloadFromValue > 9999 ? (
                  <div className="py-3">
                    <span className="error">*You can select maximum of 10000 at a time.</span>
                  </div>
                ) : (
                  <div className="py-3" />
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="col-4 p-0 m-0 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
                onClick={() => {
                  setShowDownloadImpExpModal(false);
                  setDownloadFromValue(1);
                  setDownloadToValue(100);
                }}>
                Cancel
              </button>
              <button onClick={() => downloadRangeFilter()} type="button" disabled={downloadFromValue === "" || downloadToValue === "" || downloadToValue - downloadFromValue > 9999 ? true : false} className="btn btn-primary btn-sm trademo-new-btn">
                Email
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal size="md" centered show={showConfirmModal} onHide={() => setShowConfirmModal(false)} animation={false}>
          <Modal.Header className="p-2">
            <div className="d-flex justify-content-between w-100 align-items-center">
              <div className="ml-2">
                <strong>Confirmation</strong>
              </div>
              <div>
                <Button
                  className="btn btn-primary trademo-new-btn"
                  onClick={() => {
                    if (selectedRows.length === 0) callingDownloadAPI("", true);
                    else callingDownloadAPI(selectedRows);
                    setShowConfirmModal(false);
                  }}>
                  Confirm
                </Button>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            You are downloading list of <strong>{selectedRows.length === 0 ? downloadToValue - downloadFromValue + 1 : selectedRows.length} rows </strong> which will cost you <strong>{(selectedRows.length === 0 ? downloadToValue - downloadFromValue + 1 : selectedRows.length) * 5} Download Credits</strong>.
          </Modal.Body>
        </Modal>
      </Modal>
    </div>
  );
};

export default ViewAllTrends;
